/* Global imports. */
import React from "react";

import KontentProduct from "@models/kontent/KontentProduct"

interface Props {
  products: KontentProduct[];
}

const ProductCollection = ({ products }: Props) =>  {
  return (
    <section className="product-collection-contain pm-content-module">
      <ul className="product-collection--list !pl-0 !list-none">
      {products && products.map((product:KontentProduct) => {
        return (
        <li>
          <img src={product.elements.image.value[0].url} alt={product.elements.title.value} />
          <p>{product.elements.title.value}</p>
          <a href={product.elements.button_link_url.value} className="product-link">{product.elements.button_link_text.value}</a>
        </li>
        )
      })}
      </ul>
    </section>
  )
};

export default ProductCollection;
